
import React from "react";
import { Card } from "@/components/ui/card";
import { Package, ShoppingCart } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { fetchDashboardStats } from "@/lib/api";

const AdminDashboard: React.FC = () => {
  const { data: stats, isLoading } = useQuery({
    queryKey: ["dashboardStats"],
    queryFn: fetchDashboardStats,
  });

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold tracking-tight">Dashboard</h1>
      </div>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        <Card className="p-6">
          <div className="flex items-center space-x-4">
            <div className="p-3 bg-navy-100 rounded-full">
              <Package className="h-6 w-6 text-navy-700" />
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500">
                Total de Produtos
              </p>
              <h3 className="text-2xl font-bold text-gray-900">
                {isLoading ? "..." : stats?.productCount}
              </h3>
            </div>
          </div>
        </Card>

        <Card className="p-6">
          <div className="flex items-center space-x-4">
            <div className="p-3 bg-navy-100 rounded-full">
              <ShoppingCart className="h-6 w-6 text-navy-700" />
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500">
                Total de Pedidos
              </p>
              <h3 className="text-2xl font-bold text-gray-900">
                {isLoading ? "..." : stats?.orderCount}
              </h3>
            </div>
          </div>
        </Card>
      </div>

      <Card className="p-6">
        <h2 className="text-lg font-medium mb-4">Pedidos Recentes</h2>
        {isLoading ? (
          <p>Carregando...</p>
        ) : stats?.recentOrders?.length === 0 ? (
          <p className="text-gray-500">Nenhum pedido recente</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="text-left border-b border-gray-200">
                  <th className="pb-2 font-medium text-sm text-gray-500">ID</th>
                  <th className="pb-2 font-medium text-sm text-gray-500">Cliente</th>
                  <th className="pb-2 font-medium text-sm text-gray-500">Total</th>
                  <th className="pb-2 font-medium text-sm text-gray-500">Status</th>
                  <th className="pb-2 font-medium text-sm text-gray-500">Data</th>
                </tr>
              </thead>
              <tbody>
                {stats?.recentOrders?.map((order: any) => (
                  <tr key={order.id} className="border-b border-gray-100">
                    <td className="py-3 text-sm">{order.id.substring(0, 8)}...</td>
                    <td className="py-3 text-sm">{order.customer_name}</td>
                    <td className="py-3 text-sm">
                      {Number(order.total).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                      })}
                    </td>
                    <td className="py-3 text-sm">
                      <span className={`px-2 py-1 text-xs rounded-full ${
                        order.status === 'pending'
                          ? 'bg-yellow-100 text-yellow-800'
                          : order.status === 'completed'
                          ? 'bg-green-100 text-green-800'
                          : 'bg-gray-100 text-gray-800'
                      }`}>
                        {order.status === 'pending' ? 'Pendente' : 
                         order.status === 'completed' ? 'Concluído' : order.status}
                      </span>
                    </td>
                    <td className="py-3 text-sm">
                      {new Date(order.created_at).toLocaleDateString('pt-BR')}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </div>
  );
};

export default AdminDashboard;
